export default __webpack_public_path__ + "static/media/661.64cecbd8.png";